module.exports = __webpack_public_path__ + "img/kv.80f36307.png";